import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import { IconButton } from 'components/Button';

import './index.sass'

const { cnBlock, el } = bem('page', 'error-layout');

const Page404 = ({ className, status, message }) => {
    return <div className={ cnBlock(className) } >
        <div className={ el('bg') }/>
        <div className={ el('content') }>
            <div className={ el('text', {status, 'oops': !status})}>
                <div className={el(status ? 'status' : 'oops')}>
                    <Text serif>{ status ? status : 'Ой'}</Text>
                </div>
                <div className={el('message')}>
                    <Text serif>{ message }</Text>
                </div>
            </div>
            <div className={el('button')}>
                <IconButton name={'arrow-left'} to={'/'} mod={'gold'}>
                    <Text>На главную</Text>
                </IconButton>
            </div>
        </div>
    </div>
};

export default Page404;
